import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export const FAQItem = ({
  question,
  answer
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#6805DA]/20 last:border-b-0" data-id="element-368">
      <button className="flex justify-between items-center w-full py-5 text-left" onClick={() => setIsOpen(!isOpen)} data-id="element-369">
        <h3 className="text-xl font-outfit font-semibold text-white" data-id="element-370">
          {question}
        </h3>
        <div className="text-[#FFC501]" data-id="element-371">
          {isOpen ? <ChevronUpIcon size={20} data-id="element-372" /> : <ChevronDownIcon size={20} data-id="element-373" />}
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-5' : 'max-h-0'}`} data-id="element-374">
        <p className="text-gray-300 font-manrope pr-8" data-id="element-375">{answer}</p>
      </div>
    </div>;
};